/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Review_Status_Not_Corrective_DraftInputs */

const es_co2_error_review_status_not_corrective_draft = /** @type {(inputs: Error_Review_Status_Not_Corrective_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este formulario no es un borrador correctivo editable.`)
};

/**

* @param {Error_Review_Status_Not_Corrective_DraftInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_review_status_not_corrective_draft = /** @type {((inputs?: Error_Review_Status_Not_Corrective_DraftInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Review_Status_Not_Corrective_DraftInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_review_status_not_corrective_draft(inputs)
});